exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-title h4[data-v-0c2ce374] {\n  text-overflow: unset !important;\n  width: 100% !important;\n}\nh4[data-v-0c2ce374] {\n  font-weight: bold !important;\n}\n.grid-title[data-v-0c2ce374] {\n  border-top: 1px solid #eee;\n}\n", ""]);

// exports
